/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import React, {useState, useEffect} from 'react';
import {Button, Spin, Table} from 'antd';
import useCommon from '@utils/hooks/common';
import {getLobbyEvent} from '@constant/game';
import styles from './styles';
import {autorun, intercept, toJS} from 'mobx';
import dayjs from 'dayjs';
import {ColumnsType, ColumnType} from 'antd/lib/table';
import getConfig from 'next/config';
import {useRouter} from 'next/router';
import {v4 as uuidv4} from 'uuid';

import {env} from 'next-runtime-env';

import {useInView} from 'react-intersection-observer';

export const NUMBER_OF_ROWS = 10;

const initialTableData = Array(NUMBER_OF_ROWS)
  .fill(null)
  .map(() => ({
    playerId: uuidv4(),
    playerDisplayName: '',
    gameType: '',
    wager: '',
    multiplier: '',
    payout: '',
  }));

const LiveTable = () => {
  const {classes, t, lobbySocket, system, liveTableData} = useCommon({
    withTranslation: ['home', 'game_list', 'userProfile'],
    withStyles: styles,
    observers: [
      'lobbySocket',
      'system',
      ({lobbySocket}) =>
        () => ({
          liveTableData: lobbySocket.liveTableData,
          lobbySocketCall: lobbySocket.call,
        }),
    ],
  });

  const LOBBY_EVENTS = getLobbyEvent();
  const NEXT_PUBLIC_URL = env('NEXT_PUBLIC_URL');
  const router = useRouter();

  const [tableData, setTableData] = useState(initialTableData);

  // purpose: to prevent F5 then having empty table
  const subscribeInitialPlayerStat = (): Promise<any> => {
    // console.log(' @@ subscribeInitialPlayerStat ');
    return lobbySocket.call(LOBBY_EVENTS.EM_FETCH_LATEST_PLAYER_STAT);
  };

  const {ref, inView, entry} = useInView({
    /* Optional options */
    threshold: 0,
    onChange: (inView, entry) => {
      lobbySocket.liveTableInView = inView;
      // inViewState = inView
    },
  });

  // * cant directly use the stat from mobx, need to set local state
  // useEffect(() => {

  // }, [lobbySocket, router.pathname, system?.isGameOverlayShown]);

  useEffect(() => {
    subscribeInitialPlayerStat();
  }, []);

  useEffect(() => {
    if (liveTableData.length >= NUMBER_OF_ROWS && !system.isGameOverlayShown) {
      setTableData(liveTableData);
    }
  }, [liveTableData]);

  // console.log('lobbySocket.liveTableData', JSON.stringify(liveTableData))

  const columns = [
    {
      title: t('user'),
      dataIndex: 'playerDisplayName',
      key: 'playerDisplayName',
      ellipsis: true,
      render: (text, record) => {
        const {playerIcon} = record || {};
        return (
          <div style={{display: 'flex', alignItems: 'center'}}>
            <img
              src={!playerIcon ? 'sample/avatar1.svg' : `${NEXT_PUBLIC_URL}${playerIcon}`}
              className={classes.userIcon}
            />
            <span className={classes.playerDisplayName}>{!text ? ' -- ' : `${text}`}</span>
          </div>
        );
      },
    },
    {
      title: t('game_list:game_type'),
      dataIndex: 'gameType',
      key: 'gameType',
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      render: text => (
        <span className={classes.colText}>
          {!text ? ' -- ' : `${t(`game_list:${text.toLowerCase()}`)}`}
        </span>
      ),
    },
    {
      title: t('bet_amount'),
      dataIndex: 'wager',
      key: 'wager',
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      render: text => <span className={classes.colText}>{!text ? '-- ' : `$${text}`}</span>,
    },
    {
      title: t('date'),
      dataIndex: 'timestamp',
      key: 'timestamp',
      responsive: ['lg', 'xl', 'xxl'],
      render: text => (
        <span className={classes.colText}>
          {!text ? ' -- ' : `${dayjs(text).format('MM-DD HH:mm')}`}
        </span>
      ),
    },
    {
      title: t('multiplier'),
      dataIndex: 'multiplier',
      key: 'multiplier',
      responsive: ['lg', 'xl', 'xxl'],
      render: text => <span className={classes.colText}>{!text ? ' -- ' : `${text}x`}</span>,
    },
    {
      title: t('payout'),
      dataIndex: 'payout',
      key: 'payout',
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      render: text => <span className={classes.colText}>{!text ? ' -- ' : `$${text}`}</span>,
    },
  ];

  const rowClassName = (record, index) => (index % 2 === 0 ? 'darkRow' : 'darkerRow');

  // console.log('live table render', inView,initialTableData,tableData)

  return (
    <div style={{margin: '0 10px'}} ref={ref}>
      <Table
        rowKey={record => record?.playerId}
        columns={columns as ColumnsType}
        dataSource={tableData}
        pagination={false}
        rowClassName={rowClassName}
        className={classes.antdTable}
      />
      {/* <Button onClick={subscribeInitialPlayerStat}>testing</Button> */}
    </div>
  );
};

export default LiveTable;
